import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import {
  alpha,
  Box,
  Button,
  Hidden,
  IconButton,
  Tooltip,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useContext } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import Logo from 'src/components/Logo';
import { SupportUserIcon } from 'src/components/SupportUserIcon';
import { SidebarContext } from 'src/contexts/SidebarContext';
import useAuth from 'src/hooks/useAuth';
import { useWorkspaceUserFeatures } from 'src/hooks/useWorkspaceUserFeatures';
import { feature } from 'src/models/workspaceUserFeatures.interface';

import SpaceSwitcher from '../SpaceSwitcher';
import HeaderButtons from './Buttons';
import HeaderMenu from './HeaderMenu';
import HeaderUserbox from './Userbox';
import WorkspaceSearch from './WorkspaceSearch';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 0.5)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(8px);
        box-shadow: ${theme.header.boxShadow};
        position: fixed;
        justify-content: space-between;
        width: 100%;
        gap: ${theme.spacing(1)};
`
);

function Header() {
  const theme = useTheme();
  const { user } = useAuth();
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { shouldFeatureRender } = useWorkspaceUserFeatures();

  return (
    <HeaderWrapper display="flex" alignItems="center">
      <Button
        to="/activity/list"
        component={RouterLink}
        variant="text"
        sx={{
          '&:hover': {
            background: 'none'
          }
        }}
      >
        <Logo height={28} background={theme.palette.mode} variant="icon" />
      </Button>
      <Hidden mdDown>
        <SpaceSwitcher />
        <HeaderMenu />
      </Hidden>
      <Box flexGrow={1}></Box>
      {shouldFeatureRender([feature.support.supportAdmin]) && (
        <>
          <WorkspaceSearch />
        </>
      )}
      <Box />
      <HeaderButtons />
      <HeaderUserbox />

      <Box
        component="span"
        sx={{
          display: { md: 'none', xs: 'inline-block' }
        }}
      >
        <Tooltip arrow title="Toggle Menu">
          <IconButton color="primary" onClick={toggleSidebar}>
            {!sidebarToggle ? <MenuIcon /> : <CloseIcon />}
          </IconButton>
        </Tooltip>
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
